import { trackAudioFeedbackEvents } from '@modules/feedback/components/AudioType/utils';
import useFeedbackListStore from '@modules/feedback/store/useFeedbackListStore';
import {
  ClosedCaptionDisabledRounded,
  ClosedCaptionRounded,
} from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { UUID } from 'v2/core/entities/uuid';

interface AudioTranscriptToggleButtonProps {
  feedbackID: UUID;
}

const AudioTranscriptToggleButton = ({
  feedbackID,
}: AudioTranscriptToggleButtonProps) => {
  const shouldOpenPopover = useFeedbackListStore(
    (state) => state.feedbacks[feedbackID]?.isTranscriptPopoverOpened ?? true,
  );
  const shouldExpandPopover = useFeedbackListStore(
    (state) =>
      state.feedbacks[feedbackID]?.isTranscriptPopoverExpanded ?? false,
  );
  const setIsTranscriptPopoverOpened = useFeedbackListStore(
    (state) => state.setIsTranscriptPopoverOpened,
  );
  const setIsTranscriptPopoverExpanded = useFeedbackListStore(
    (state) => state.setIsTranscriptPopoverExpanded,
  );

  const onToggle = () => {
    setIsTranscriptPopoverOpened(!shouldOpenPopover, feedbackID);
    if (shouldOpenPopover && shouldExpandPopover) {
      setIsTranscriptPopoverExpanded(false, feedbackID);
    }
    trackAudioFeedbackEvents({
      eventName: shouldOpenPopover
        ? 'Audio Feedback - Transcript: Toggled Off'
        : 'Audio Feedback - Transcript: Toggled On',
      feedbackID,
    });
  };

  return (
    <IconButton color="primary" size="small" onClick={onToggle}>
      {shouldOpenPopover ? (
        <ClosedCaptionRounded fontSize="large" />
      ) : (
        <ClosedCaptionDisabledRounded fontSize="large" />
      )}
    </IconButton>
  );
};

export default AudioTranscriptToggleButton;
